module.exports = __webpack_public_path__ + "img/mastercard.e56b2d50.svg";